import RestService from "./restService";
import { BLACK_LIST } from "../../url/hiring";
const singleton = Symbol();
const singletonEnforcer = Symbol();
/**
 *
 */
class BlackListService extends RestService {
  constructor(enforcer) {
    super(BLACK_LIST);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Agency RestService more than one");
  }
  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new BlackListService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default BlackListService;
